module.exports = __webpack_public_path__ + "img/neotasLogo.a458945b.png";